import { StanButton, StanInput, StanTextArea } from '@/components';
import { useCustomizationStore } from '@/features/theme-editor/stores/customizationStore';
import { Header as HeaderData } from '@/types/store';
import { isEqual } from 'lodash';
import { useState } from 'react';
import { Panel, PanelFooter } from '../../Panel';
import { Icon } from '../../ui/Icon';
import { ImageUpload } from '../../ui/ImageUpload';
import { Label } from '../../ui/Label';

export const Header = () => {
    const { cachedState, header, updateStoreHeader } = useCustomizationStore();
    const { title, bio, image } = header ?? {};
    const [cachedHeader] = useState<HeaderData | null>(cachedState?.header ?? null);

    const maxTitleCount = 50;
    const maxBioCount = 240;

    const resetHeader = () => {
        if (cachedHeader) updateStoreHeader(cachedHeader);
    };

    const isDirty = !isEqual(cachedHeader, header);

    return (
        <Panel
            footer={
                <PanelFooter>
                    {cachedHeader && isDirty && (
                        <div className='absolute left-1/2 -translate-x-1/2'>
                            <StanButton
                                name='revert'
                                onClick={resetHeader}
                                color='secondary'
                                variant='outline'
                                size='sm'
                                className='aspect-square !h-auto w-10 !min-w-0 !p-0'
                                icon={<Icon name='revert' className='relative left-0.5' />}
                            />
                        </div>
                    )}
                </PanelFooter>
            }
        >
            <Label
                label='Title'
                required
                currentCount={title?.length?.toString() ?? '0'}
                totalCount={maxTitleCount.toString()}
            >
                <StanInput
                    name='title'
                    placeholder='Section Title'
                    onChange={event => updateStoreHeader({ title: event.target.value.slice(0, maxTitleCount) ?? '' })}
                    value={title ?? ''}
                />
            </Label>
            <div className='mx-auto max-w-[160px]'>
                <ImageUpload
                    image={image}
                    aspectRatio={4 / 3}
                    onUpdate={image => updateStoreHeader({ image })}
                    className='aspect-4/3'
                />
            </div>
            <Label label='Bio' currentCount={bio?.length?.toString() ?? '0'} totalCount={maxBioCount.toString()}>
                <StanTextArea
                    id='bio'
                    onChange={event => updateStoreHeader({ bio: event.target.value.slice(0, maxBioCount) ?? '' })}
                    value={bio ?? ''}
                />
            </Label>
        </Panel>
    );
};
